import GenericImage from '@/components/generic/GenericImage'
import GenericText from '@/components/generic/GenericText'
import GenericGutter from '@/components/generic/GenericGutter'
import GenericButton from '@/components/generic/GenericButton'
import GenericInput from '@/components/generic/GenericInput'
import GenericDatePicker from '@/components/generic/GenericDatePicker'

export default {
  components: {
    GenericImage,
    GenericText,
    GenericGutter,
    GenericButton,
    GenericInput,
    GenericDatePicker
  },
  data() {
    return {
      components: []
    }
  },
  methods: {
    getComponentType(type) {
      let componentType = ''

      switch (type) {
        case 'image':
          componentType = 'generic-image'
          break
        case 'text':
          componentType = 'generic-text'
          break
        case 'gutter':
          componentType = 'generic-gutter'
          break
        case 'button':
          componentType = 'generic-button'
          break
        case 'input':
          componentType = 'generic-input'
          break
        case 'date-picker':
          componentType = 'generic-date-picker'
          break
        default:
          break
      }

      return componentType
    }
  },
}
